export default {
  namespaced: true,
  state: {
    isDisplay: false,
    type: null
  },
  mutations: {
    changeDisplay(state, isDisplay) {
      state.isDisplay = isDisplay;
    },
    changeType(state, { type }) {
      state.type = type;
    }
  },
  actions: {
    async openDisplay({ commit }, { type }) {
      await commit("changeType", { type });
      commit("changeDisplay", true);
    },
    async closeDisplay({ commit }) {
      await commit("changeType", { type: null });
      commit("changeDisplay", false);
    }
  }
};
